import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV } from "@/lib/marketing";
import { SignInDialog } from "@/components/marketing/SignInDialog";

const NavLink = ({ item, mobile }) => (
  <a href={item.href} aria-current={item.current ? "page" : undefined}
     data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}${mobile ? "-mobile" : ""}`}
     className={`text-sm transition-colors duration-200 ${mobile ? "block py-2" : ""} ${item.current
       ? "font-semibold text-[#275C3F] border-b-2 border-[#275C3F] pb-0.5"
       : "text-[#4B5950] hover:text-[#275C3F]"}`}>
    {item.label}
  </a>
);

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-30 bg-[#F8FAF8]/90 backdrop-blur border-b border-[#DCE3DD]">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between gap-6">
        <a href="/" className="flex items-center shrink-0" data-testid="brand-home-link" aria-label="EnviSafe home">
          <img src="/brand/envisafe-lockup-light.svg" alt="EnviSafe" className="h-8 w-auto" data-testid="brand-lockup-light" />
        </a>
        <nav className="hidden xl:flex items-center gap-6" data-testid="site-nav">
          {NAV.map((n) => <NavLink key={n.label} item={n} />)}
        </nav>
        <div className="flex items-center gap-2">
          <SignInDialog />
          <button className="xl:hidden p-2" aria-label="Menu" data-testid="nav-mobile-toggle" onClick={() => setOpen((v) => !v)}>
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="xl:hidden border-t border-[#DCE3DD] bg-[#F8FAF8] px-6 py-3" data-testid="site-nav-mobile">
          {NAV.map((n) => <NavLink key={n.label} item={n} mobile />)}
        </nav>
      )}
    </header>
  );
};
